import * as React from "react";
import { SVGProps } from "react";
const SvgPreloaderAutomations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="preloader-automations_svg__eWvO3UaXV6I1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 906 330"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    {...props}
  >
    <style>
      {
        "@keyframes eWvO3UaXV6I3__sz{0%{width:246.533893px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}46.666667%{width:399.789551px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}to{width:246.526229px;height:22.041109px}}@keyframes eWvO3UaXV6I5__sz{0%{width:473.548526px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}46.666667%{width:246.533893px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}to{width:473.548526px;height:22.041109px}}@keyframes eWvO3UaXV6I7__sz{0%{width:246.533893px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}46.666667%{width:420.893135px;height:22.041109px;animation-timing-function:cubic-bezier(.42,0,.58,1)}to{width:246.529805px;height:22.041109px}}"
      }
    </style>
    <rect
      width={906}
      height={102}
      rx={12}
      ry={12}
      fill="#f9f9f9"
      strokeWidth={0}
    />
    <rect
      width={246.534}
      height={22.041}
      rx={7}
      ry={7}
      transform="matrix(.62533 0 0 1 13.824 12.682)"
      fill="#efefef"
      strokeWidth={0}
      style={{
        animation: "eWvO3UaXV6I3__sz 1500ms linear infinite normal forwards",
      }}
    />
    <rect
      width={906}
      height={102}
      rx={12}
      ry={12}
      transform="translate(0 114)"
      fill="#fbfbfb"
      strokeWidth={0}
    />
    <rect
      width={473.549}
      height={22.041}
      rx={7}
      ry={7}
      transform="matrix(.52793 0 0 1 13.824 125.758)"
      fill="#f4f4f4"
      strokeWidth={0}
      style={{
        animation: "eWvO3UaXV6I5__sz 1500ms linear infinite normal forwards",
      }}
    />
    <rect
      width={906}
      height={102}
      rx={12}
      ry={12}
      transform="translate(0 228)"
      fill="#fcfcfc"
      strokeWidth={0}
    />
    <rect
      width={246.534}
      height={22.041}
      rx={7}
      ry={7}
      transform="matrix(.68901 0 0 1 13.824 240.682)"
      fill="#f7f7f7"
      strokeWidth={0}
      style={{
        animation: "eWvO3UaXV6I7__sz 1500ms linear infinite normal forwards",
      }}
    />
  </svg>
);
export default SvgPreloaderAutomations;
